import React from "react";
import "../Styles/Footer.css";
import { Box, Divider, Grid, IconButton, Typography } from "@mui/material";
import Logo from "../Images/CG LOGO white.png";
import { Link } from "react-router-dom";
import { Facebook, Instagram, LinkedIn, YouTube } from "@mui/icons-material";

export default function Footer() {
  return (
    <Grid className="footer-container text">
      <Grid container py={3} spacing={2}>
        <Grid item xs={12} sm={4}>
          <div className="footer-links">
            <Typography
              variant="h6"
              color="rgb(136, 144, 146)"
              fontWeight={600}
              fontFamily={"Poppins, serif"}
            >
              Quicks Links
            </Typography>
            <Link to="/">Home</Link>
            {/* <Link to="/Career">Career</Link> */}
            <Link to="/Gallery">Gallery</Link>
            <Link to="/Blog">Blog</Link>
            <Link to="/About">About</Link>
            <Link to="/Contact">Contact</Link>
          </div>
        </Grid>
        <Grid item xs={12} sm={4}>
          <div className="footer-links">
            <Typography
              variant="h6"
              color="rgb(136, 144, 146)"
              fontWeight={600}
              fontFamily={"Poppins, serif"}
            >
              Our Showrooms
            </Typography>
            <a
              href="https://centralkia.co.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Central Kia
            </a>
            <a
              href="https://www.thecentralhonda.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Central Honda
            </a>
            <a
              href="https://renaultcentral.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Central Renault
            </a>
            <a href="https://commercial-vehicles.fleetverse.tatamotors.com/tata-motors-commercial-vehicle-dealer-consortium-automobiles-pvt-ltd-truck-dealers-khordha-bhubaneswar-190520/Home?utm_source=locator&utm_medium=googleplaces" target="_blank"
              rel="noopener noreferrer">Consortium Automobiles</a>
            <a
              href="https://www.mgcentral.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              MG Central
            </a>
            <a
              href="https://centralbyd.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Central BYD
            </a>
          </div>
        </Grid>
        <Grid item xs={12} sm={4}>
          <div className="footer-social">
            <IconButton
              LinkComponent={"a"}
              className="footer-icon-button"
              href="https://www.facebook.com/share/194z5hUm1T/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook />
            </IconButton>
            <IconButton
              LinkComponent={"a"}
              className="footer-icon-button"
              href="https://www.instagram.com/centralgroup1/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram />
            </IconButton>
            <IconButton
              LinkComponent={"a"}
              className="footer-icon-button"
              href="https://www.linkedin.com/company/the-central-group-bbsr/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedIn />
            </IconButton>
            <IconButton
              LinkComponent={"a"}
              className="footer-icon-button"
              href="https://youtube.com/@central_group?si=Lt-VCB5C1suJoTos/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <YouTube />
            </IconButton>
          </div>
          <div className="footer-links" style={{ marginTop: "auto" }}>
            <Link to="/">Privacy & Policy</Link>
            <Link to="/">Terms and Conditions</Link>
          </div>
        </Grid>
      </Grid>

      <Divider style={{ height: "0.1px", backgroundColor: "white" }} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          height: "100px",
        }}
      >
        {/* center-aligned Image */}
        <Link to="/">
          <img
            src={Logo}
            alt="central group"
            style={{
              width: "190px",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Link>
      </Box>
      <div className="footer-copyright">
        <Grid item xs={12} textAlign={"center"}>
          <Typography className="text">
            For any assistance contact us at: 07941050759, Email:
            support@centralgroup.co.in
          </Typography>
          <Typography className="text">
            Central Group by CONSORTIUM MOTORS PVT LTD <br />
            All Rights Reserved. &copy; 2026 Central Group by CONSORTIUM MOTORS
            PVT LTD
          </Typography>
        </Grid>
        <Typography
          className="text"
          sx={{
            display: "flex",
            paddingTop: "30px",
            fontSize: "14px",
          }}
        >
          Designed & Developed by: J Nine Infotech
        </Typography>
      </div>
    </Grid>
  );
}
